"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledZoomOutButton = exports.StyledZoomOut = exports.StyledZoomInstructions = exports.StyledZoomButton = exports.StyledVisualizerWrapper = exports.StyledVisualizerRatioBox = exports.StyledVisualizer = exports.StyledRatioBox = exports.StyledLoadSpinner = exports.StyledLoadArea = exports.StyledCaption = exports.StyledActions = exports.StyledActionItem = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _MdZoomOutMap = require("@react-icons/all-files/md/MdZoomOutMap");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tachyons = require("../../framework/tachyons");

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _Button = _interopRequireDefault(require("../Button/Button.index"));

var _RatioBox = _interopRequireDefault(require("../RatioBox/RatioBox.index"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner.index"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;

var StyledActions = _styledComponents["default"].ul.withConfig({
  displayName: "Visualizerstyles__StyledActions",
  componentId: "sc-1v43bma-0"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["absolute top-1 right-1 list ma0 pa0 z-2"]))));

exports.StyledActions = StyledActions;

var StyledActionItem = _styledComponents["default"].li.withConfig({
  displayName: "Visualizerstyles__StyledActionItem",
  componentId: "sc-1v43bma-1"
})(["", ""], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["mb2"]))));

exports.StyledActionItem = StyledActionItem;

var StyledVisualizer = _styledComponents["default"].section.withConfig({
  displayName: "Visualizerstyles__StyledVisualizer",
  componentId: "sc-1v43bma-2"
})(["height:fit-content;transition:position 0.1s,top 0.05s linear,width 0.1s ease-in-out;", " ", ""], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    w-100 sticky fixed-m top-0 top-1-ns bg-white dit right-1-m z-3 mb3-l bg-grey\n    ", "\n  "])), function (_ref) {
  var isMinimized = _ref.isMinimized,
      shouldEnableMinimization = _ref.shouldEnableMinimization;
  return shouldEnableMinimization && (isMinimized ? 'fixed top-1 right-1 shadow-light-1 br2 w-40 w-25-m' : 'w-100 w-50-m fr');
}), function (_ref2) {
  var isMinimized = _ref2.isMinimized,
      shouldEnableMinimization = _ref2.shouldEnableMinimization,
      _ref2$theme$visualize = _ref2.theme.visualizer.design;
  _ref2$theme$visualize = _ref2$theme$visualize === void 0 ? {} : _ref2$theme$visualize;
  var _ref2$theme$visualize2 = _ref2$theme$visualize.fixedTopPosition,
      fixedTopPosition = _ref2$theme$visualize2 === void 0 ? {} : _ref2$theme$visualize2,
      top = _ref2.top;
  return "\n    ".concat(isMinimized && shouldEnableMinimization && !top && "\n        ".concat(_tachyons.breakpoints.s, " {\n          top: ").concat(fixedTopPosition.small, ";\n        }\n        ").concat(_tachyons.breakpoints.m, " {\n          top: ").concat(fixedTopPosition.medium, ";\n        }\n        ").concat(_tachyons.breakpoints.l, " {\n          top: ").concat(fixedTopPosition.large, ";\n        }\n      "), "\n    ").concat(isMinimized && shouldEnableMinimization && !!top && "\n        top: ".concat(top, "px;\n      "), "\n  ");
});

exports.StyledVisualizer = StyledVisualizer;
var StyledVisualizerRatioBox = (0, _styledComponents["default"])(_RatioBox["default"]).withConfig({
  displayName: "Visualizerstyles__StyledVisualizerRatioBox",
  componentId: "sc-1v43bma-3"
})(["", ""], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["br2-l shadow-1-ns"]))));
exports.StyledVisualizerRatioBox = StyledVisualizerRatioBox;

var StyledVisualizerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Visualizerstyles__StyledVisualizerWrapper",
  componentId: "sc-1v43bma-4"
})(["", ""], (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["h-100 flex flex-wrap flex-row flex-column-ns items-center justify-center tc overflow-hidden"]))));

exports.StyledVisualizerWrapper = StyledVisualizerWrapper;

var StyledCaption = _styledComponents["default"].div.withConfig({
  displayName: "Visualizerstyles__StyledCaption",
  componentId: "sc-1v43bma-5"
})(["", " text-align:", ";"], (0, _ty["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["f7 w-100 ph5 ph2-ns tc pt2 black-40"]))), function (props) {
  return props.alignment;
});

exports.StyledCaption = StyledCaption;
var StyledRatioBox = (0, _styledComponents["default"])(_RatioBox["default"]).withConfig({
  displayName: "Visualizerstyles__StyledRatioBox",
  componentId: "sc-1v43bma-6"
})(["", " & [class*=\"StyledAspectRatioObject\"]{", "}"], (0, _ty["default"])(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["w2"]))), (0, _ty["default"])(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["flex items-center justify-center"]))));
exports.StyledRatioBox = StyledRatioBox;
var StyledZoomButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "Visualizerstyles__StyledZoomButton",
  componentId: "sc-1v43bma-7"
})(["", " width:6rem;"], (0, _ty["default"])(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["ph0 h2"]))));
exports.StyledZoomButton = StyledZoomButton;
var StyledZoomOutButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "Visualizerstyles__StyledZoomOutButton",
  componentId: "sc-1v43bma-8"
})(["", ""], (0, _ty["default"])(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["absolute top-0 right-0 ma2 z-1"]))));
exports.StyledZoomOutButton = StyledZoomOutButton;
var StyledZoomOut = (0, _styledComponents["default"])(_MdZoomOutMap.MdZoomOutMap).withConfig({
  displayName: "Visualizerstyles__StyledZoomOut",
  componentId: "sc-1v43bma-9"
})(["", ""], (0, _ty["default"])(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["f3"]))));
exports.StyledZoomOut = StyledZoomOut;

var StyledZoomInstructions = _styledComponents["default"].div.withConfig({
  displayName: "Visualizerstyles__StyledZoomInstructions",
  componentId: "sc-1v43bma-10"
})(["", " ", " font-size:.875rem;background:rgba(0,0,0,0.5);transition-duration:500ms;transition-property:opacity;pointer-events:none;> p{margin-left:1rem;}"], (0, _ty["default"])(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["absolute z-1 w-100 h-100 top-0 left-0 white flex flex-column items-center justify-center fw7"]))), function (_ref3) {
  var visible = _ref3.visible;
  return visible ? 'opacity:1;' : 'opacity:0;';
});

exports.StyledZoomInstructions = StyledZoomInstructions;

var StyledLoadArea = _styledComponents["default"].div.withConfig({
  displayName: "Visualizerstyles__StyledLoadArea",
  componentId: "sc-1v43bma-11"
})(["", " pointer-events:none;", " transition-duration:100ms;transition-property:opacity;"], (0, _ty["default"])(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2["default"])(["w-100 h-100 bg-mid-gray absolute flex flex-wrap flex-row flex-column-ns items-center justify-center tc"]))), function (_ref4) {
  var isLoading = _ref4.isLoading;
  return isLoading ? 'opacity:1;' : 'opacity:0;';
});

exports.StyledLoadArea = StyledLoadArea;
var StyledLoadSpinner = (0, _styledComponents["default"])(_Spinner["default"]).withConfig({
  displayName: "Visualizerstyles__StyledLoadSpinner",
  componentId: "sc-1v43bma-12"
})(["", " pointer-events:none;"], (0, _ty["default"])(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2["default"])(["w-20 w-25-s o-70"]))));
exports.StyledLoadSpinner = StyledLoadSpinner;